import { PromptConfigBuilder } from ".";
import { useParams } from "react-router-dom";

export default function PromptConfigPage() {
  const { roleId } = useParams<{ roleId: string }>();

  return (
    <div className="min-h-screen bg-gray-100 pb-10 pt-4 dark:bg-darkbg">
      <PromptConfigBuilder roleId={roleId} />
    </div>
  );
}
